import { MutableRefObject, useCallback } from 'react'
import { GooglePlaceResult, GooglePlaceSearchResults } from 'types/location'
import { useConfigurePlaces } from './useConfigurePlaces'
type PlaceRef = GooglePlaceSearchResults
type Place = GooglePlaceResult

export const usePlaces = (
  boxRef: MutableRefObject<HTMLDivElement | null>
): {
  query: ({
    query,
  }: {
    query: string
    countryCode?: string
  }) => Promise<PlaceRef[]>
  select: ({ placeId }: { placeId: string }) => Promise<Place>
} => {
  const { getPredictions, refreshToken, getPlace } = useConfigurePlaces(boxRef)

  const query = useCallback(
    async ({ query, countryCode }) => {
      try {
        const results = await getPredictions({ query, countryCode })
        const places = results.map(
          ({ description, place_id }: GooglePlaceSearchResults) => ({
            description,
            place_id,
            id: place_id,
          })
        )
        return places
      } catch (e) {
        throw Error('Failed to load autocomplete data.')
      }
    },
    [getPredictions]
  )

  const select = useCallback(
    async (place_id) => {
      try {
        const result = (await getPlace(place_id)) as GooglePlaceResult
        refreshToken()
        return result
      } catch (e) {
        throw e
      }
    },
    [getPlace, refreshToken]
  )

  return { query, select }
}
